/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Studio_TitleInputs */

const en_for_whom_studio_title = /** @type {(inputs: For_Whom_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole team in one schedule.`)
};

const pl_for_whom_studio_title = /** @type {(inputs: For_Whom_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały zespół w jednym grafiku.`)
};

/**
* | output |
* | --- |
* | "The whole team in one schedule." |
*
* @param {For_Whom_Studio_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_studio_title = /** @type {((inputs?: For_Whom_Studio_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Studio_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_studio_title(inputs)
	return en_for_whom_studio_title(inputs)
});